import { Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { sexoKeyToLabel } from "../../../detalhes-do-projeto/filtros/sexo"
import { ISexo } from "../../../../../../../application/models"
// Icon
import WcIcon from '@mui/icons-material/Wc'

export const RecorteSexoFilterPreview = (props: {
    sexoFilter?: ISexo[]
}) => {

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2} p={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Sexo
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                        >
                            {props.sexoFilter && props.sexoFilter.map((sexo, i) => (
                                <Chip
                                    key={i}
                                    icon={<WcIcon />}
                                    label={sexoKeyToLabel(sexo).toUpperCase()}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            ))}
                        </Stack>
                    </Grid>
                </Paper>
            </Grid>
        </>
    )
}